import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

/**
 * Confirmation popup shown before a sample collection is submitted.
 *
 * @param {boolean} show - Whether the modal is visible
 * @param {string} participantName - Participant name shown in bold in the message
 * @param {function} onCancel - Called on Cancel / close icon / backdrop click
 * @param {function} onConfirm - Called on "Confirm & submit"
 * @param {boolean} isLoading - Disables the buttons while submitting
 */
function VHSubmitConfirmModal({
  show,
  participantName,
  onCancel,
  onConfirm,
  isLoading,
}) {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdropClassName="vh-submit-confirm-backdrop"
      className="vh-submit-confirm-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Are you sure you want to submit?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You&apos;re about to submit the sample collection for{" "}
          <span className="boots-bold">{participantName}</span>. Please ensure
          all details are correct before submitting.
        </p>
        <p>Once submitted, the test order cannot be edited.</p>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="boots-secondary-btn-styling"
          disabled={isLoading}
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>
        <button
          className="boots-primary-btn-styling"
          disabled={isLoading}
          onClick={onConfirm}
          type="button"
        >
          Confirm &amp; submit
        </button>
      </Modal.Footer>
    </Modal>
  );
}

VHSubmitConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  participantName: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

VHSubmitConfirmModal.defaultProps = {
  participantName: "",
  isLoading: false,
};

export default VHSubmitConfirmModal;
